import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import "../../css/styles.css";
import Swal from "sweetalert2";
import { urlService } from "../../utils/url";
import axios from "axios";

const categorias = [
    { value: "noticias", label: "Noticias" },
    { value: "editorial", label: "Editorial" },
    { value: "estudios", label: "Estudios" },
    { value: "tendencia", label: "Tendencia" },
];

const FormBlog = () => {
    const history = useHistory();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        categoria: "",
        titulo: "",
        bajada: "",
        cuerpo: "",
        imagen: null,
        documento: null,
        esExterno: false,
        firmaApellido: "",
        firmaFecha: "",
        firmaTituloNoticia: "",
        firmaNombrePeriodico: "",
        firmaUrl: ""
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchArticle = async () => {
                try {
                    const response = await axios.get(`${urlService}/api/blog/admin/${id}`);
                    const article = response.data;
                    setFormData({
                        ...article,
                        categoria: article.categoria || "",
                        titulo: article.titulo || "",
                        bajada: article.bajada || "",
                        cuerpo: article.cuerpo || "",
                        imagen: article.imagen || null,
                        documento: article.documento || null,
                        esExterno: article.esExterno || false,
                        firmaApellido: article.firmaApellido || "",
                        firmaFecha: article.firmaFecha || "",
                        firmaTituloNoticia: article.firmaTituloNoticia || "",
                        firmaNombrePeriodico: article.firmaNombrePeriodico || "",
                        firmaUrl: article.firmaUrl || ""
                    });
                } catch (error) {
                    console.error("Error al obtener el artículo", error);
                    Swal.fire("Error", "No se pudo cargar el artículo.", "error");
                }
            };
            fetchArticle();
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === "checkbox") {
            setFormData({ ...formData, [name]: checked });
        } else if (type === "file") {
            const file = files[0];
            if (file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    setFormData({
                        ...formData,
                        [name]: {
                            Name: file.name,
                            Value: reader.result,
                            DownloadLink: "",
                            EsPortada: false,
                            ContainerName: ""
                        }
                    });
                };
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleVolver = () => {
        history.push("/blog");
    };

    const handleGuardar = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            let dataToSend = { ...formData };
            if (!dataToSend.esExterno) {
                // For internal articles: get logged-in user email
                const userStr = localStorage.getItem("user");
                const user = userStr ? JSON.parse(userStr) : null;
                dataToSend.autor = user ? user.mail : "";
                
                // Clear external firm fields
                dataToSend.firmaApellido = "";
                dataToSend.firmaFecha = "";
                dataToSend.firmaTituloNoticia = "";
                dataToSend.firmaNombrePeriodico = "";
                dataToSend.firmaUrl = "";
            } else {
                // For external articles: clear author email
                dataToSend.autor = "";
            }

            if (id) {
                await axios.put(`${urlService}/api/blog/${id}`, { ...dataToSend, id });
                Swal.fire({
                    title: "Guardado",
                    text: "Artículo actualizado con éxito",
                    icon: "success",
                    confirmButtonText: "Ok"
                }).then(() => {
                    history.push("/blog");
                });
            } else {
                await axios.post(`${urlService}/api/blog`, dataToSend);
                Swal.fire({
                    title: "Guardado",
                    text: "Artículo creado con éxito",
                    icon: "success",
                    confirmButtonText: "Ok"
                }).then(() => {
                    history.push("/blog");
                });
            }
        } catch (error) {
            console.error("Error guardando artículo", error);
            Swal.fire("Error", "No se pudo guardar el artículo.", "error");
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contenido" style={{ minWidth: 0, width: '100%' }}>
            <div className="header">
                <h2>{id ? "Editar Artículo" : "Agregar Artículo"}</h2>
            </div>
            <Grid container spacing={2} sx={{ mt: 2, mb: 2, p: 2 }}>
                <Grid item xs={12} sm={12} md={8}>
                    <label className="milabel">Título</label>
                    <input
                        type="text"
                        name="titulo"
                        value={formData.titulo}
                        onChange={handleChange}
                        className="miSelect"
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <label className="milabel">Categoría</label>
                    <select
                        name="categoria"
                        value={formData.categoria}
                        onChange={handleChange}
                        className="selectFullWidth"
                    >
                        <option value="">- Seleccione -</option>
                        {categorias.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </Grid>
                <Grid item xs={12}>
                    <label className="milabel">Bajada</label>
                    <textarea
                        name="bajada"
                        value={formData.bajada}
                        onChange={handleChange}
                        className="miSelect"
                        rows={3}
                        style={{ height: 'auto', width: '100%', resize: 'vertical' }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <label className="milabel">Cuerpo</label>
                    <textarea
                        name="cuerpo"
                        value={formData.cuerpo}
                        onChange={handleChange}
                        className="miSelect"
                        rows={10}
                        style={{ height: 'auto', width: '100%', resize: 'vertical' }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <label className="milabel">Imagen</label>
                    {formData.imagen ? (
                        <div style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{ fontSize: '14px', color: '#333', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {formData.imagen.Name || formData.imagen.name || (typeof formData.imagen === 'string' ? formData.imagen.split('/').pop() : "Imagen cargada")}
                                </span>
                                <button
                                    type="button"
                                    onClick={() => setFormData({ ...formData, imagen: null })}
                                    style={{ background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer', fontSize: '12px' }}
                                >
                                    Eliminar
                                </button>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <img 
                                    src={typeof formData.imagen === 'string' ? formData.imagen : (formData.imagen.Value || formData.imagen.value || formData.imagen.DownloadLink || formData.imagen.downloadLink)} 
                                    alt="Vista previa" 
                                    style={{ maxWidth: '100%', maxHeight: '150px', objectFit: 'contain', borderRadius: '4px' }}
                                />
                            </div>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="imagen"
                            onChange={handleChange}
                            accept="image/*"
                            className="miSelectSubirArchivo"
                            style={{ padding: '8px' }}
                        />
                    )}
                </Grid>

                <Grid item xs={12} sm={6}>
                    <label className="milabel">Documento</label>
                    {formData.documento ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9' }}>
                            <span style={{ fontSize: '14px', color: '#333', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {formData.documento.Name || formData.documento.name || (typeof formData.documento === 'string' ? formData.documento.split('/').pop() : "Documento cargado")}
                            </span>
                            <a
                                href={typeof formData.documento === 'string' ? formData.documento : (formData.documento.Value || formData.documento.value || formData.documento.DownloadLink || formData.documento.downloadLink || "#")}
                                download={formData.documento.Name || formData.documento.name || "documento"}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ background: '#007bff', color: 'white', textDecoration: 'none', borderRadius: '4px', padding: '4px 8px', fontSize: '12px' }}
                            >
                                Descargar
                            </a>
                            <button
                                type="button"
                                onClick={() => setFormData({ ...formData, documento: null })}
                                style={{ background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer', fontSize: '12px' }}
                            >
                                Eliminar
                            </button>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="documento"
                            onChange={handleChange}
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.csv"
                            className="miSelectSubirArchivo"
                            style={{ padding: '8px' }}
                        />
                    )}
                </Grid>

                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                    <FormControlLabel
                        control={<Checkbox checked={formData.esExterno} onChange={handleChange} name="esExterno" color="primary" />}
                        label={<span className="milabel" style={{ marginBottom: 0 }}>Artículo Externo</span>}
                    />
                </Grid>

                {formData.esExterno && (
                    <>
                        <Grid item xs={12}>
                            <h4 style={{ margin: '10px 0 0 0', color: '#333' }}>Firma del Artículo Externo</h4>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label className="milabel">Apellido, N.</label>
                            <input
                                type="text"
                                name="firmaApellido"
                                value={formData.firmaApellido}
                                onChange={handleChange}
                                className="miSelect"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label className="milabel">Fecha completa</label>
                            <input
                                type="date"
                                name="firmaFecha"
                                value={formData.firmaFecha}
                                onChange={handleChange}
                                className="miSelect"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label className="milabel">Título de la noticia</label>
                            <input
                                type="text"
                                name="firmaTituloNoticia"
                                value={formData.firmaTituloNoticia}
                                onChange={handleChange}
                                className="miSelect"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label className="milabel">Nombre del Periódico</label>
                            <input
                                type="text"
                                name="firmaNombrePeriodico"
                                value={formData.firmaNombrePeriodico}
                                onChange={handleChange}
                                className="miSelect"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <label className="milabel">URL</label>
                            <input
                                type="text"
                                name="firmaUrl"
                                value={formData.firmaUrl}
                                onChange={handleChange}
                                className="miSelect"
                            />
                        </Grid>
                    </>
                )}

                <Grid item xs={12} sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'flex-start' }}>
                    <button className="boton" onClick={handleGuardar} disabled={isSubmitting}>
                        {isSubmitting ? "Guardando..." : "Guardar"}
                    </button>
                    <button className="botonSecundario" onClick={handleVolver} disabled={isSubmitting}>
                        Cancelar
                    </button>
                </Grid>
            </Grid>
        </div>
    );
};

export default FormBlog;
